import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  onPreviousMonth, 
  onNextMonth, 
  onToday,
  selectedFilters,
  onFilterToggle 
}) => {
  const monthYear = currentDate?.toLocaleDateString('en-US', { 
    month: 'long', 
    year: 'numeric' 
  });

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <button
          onClick={onPreviousMonth}
          className="w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-smooth"
          aria-label="Previous month"
        >
          <Icon name="ChevronLeft" size={20} className="text-foreground" />
        </button>
        
        <h2 className="text-xl md:text-2xl font-semibold text-foreground min-w-[200px] text-center">
          {monthYear}
        </h2>
        
        <button
          onClick={onNextMonth}
          className="w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-smooth"
          aria-label="Next month"
        >
          <Icon name="ChevronRight" size={20} className="text-foreground" />
        </button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={onToday}
          className="ml-2"
        >
          Today
        </Button>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm text-muted-foreground mr-2">Show:</span>
        
        <button
          onClick={() => onFilterToggle('appointments')}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
            selectedFilters?.appointments
              ? 'bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          <Icon name="Calendar" size={16} />
          Appointments
        </button>
        
        <button
          onClick={() => onFilterToggle('deliveries')}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
            selectedFilters?.deliveries
              ? 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-600 dark:text-yellow-400' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          <Icon name="Package" size={16} />
          Deliveries
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;